// extracted by mini-css-extract-plugin
export var equalColumn = "_fy-0";